export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

const GUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * True only for a real, persisted GUID: a valid GUID format that is not the
 * all-zero empty GUID.
 *
 * A not-yet-saved entity (e.g. the "הוסף לקוח" tab) carries a temporary id such
 * as Date.now() ("1784197949187") or the empty GUID. Since the DB moved to
 * PostgreSQL, sending such a value where a uuid column is expected throws
 * "invalid input syntax for type uuid" (on SQL Server it silently returned
 * nothing), so callers should skip customer-scoped server calls when this is false.
 */
export const isRealGuid = (value: unknown): boolean =>
    typeof value === 'string' && value !== EMPTY_GUID && GUID_RE.test(value);
